// extracted by mini-css-extract-plugin
module.exports = {"description":"description__RsIHM","amount":"amount__37QGd"};